import script from "./ErrorPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ErrorPage.vue?vue&type=script&setup=true&lang=js"

import "./ErrorPage.vue?vue&type=style&index=0&id=5a4abb6f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a4abb6f"]])

export default __exports__